<template>
  <div class="form-group row">
    <label
      :for="labelId"
      class="col-4 col-form-label">{{labelText}}
    </label>
    <div class="col-8">
      <label class="switch switch-lg switch-3d switch-primary mr-1">
        <input
          :id="labelId"
          v-model="enabled"
          class="switch-input"
          type="checkbox"
          @click="$emit('input', !enabled)">
        <span class="switch-label"></span>
        <span class="switch-handle"></span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminFormCheckBox',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    labelText: {
      type: String,
      default: ''
    },
    labelId: {
      type: String,
      default: 'label' + Math.random()
    }
  },
  data () {
    return {
      enabled: this.value
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AdminFormCheckBox.vue?5de7dc04